import { _ as __read } from '../../../../_tslib-7a01aab4.js';
import React, { useState, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import '../../../core/enums/GameSpecificTypes.js';
import '../../../core/enums/MaxPayoutDataTypes.js';
import '../../../core/enums/Chat.js';
import '../../../core/enums/GameModes.js';
import '../../../core/enums/IconTypes.js';
import '../../../core/enums/BetStatus.js';
import '../../../core/enums/PopupTypes.js';
import '../../../core/enums/ApiVersion.js';
import '../../../core/enums/RoundStatus.js';
import '../../../core/enums/FreeBetsStatus.js';
import '../../../core/enums/SocketEvents.js';
import '../../../core/enums/TranslationKeys.js';
import '../../../core/enums/TimeoutMaxValue.js';
import '../../../core/enums/ApiServiceTypes.js';
import '../../../core/enums/EnvironmentTypes.js';
import '../../../core/enums/DefaultQueryValues.js';
import '../../../core/enums/FreeBetWinningType.js';
import '../../../core/enums/DefaultQueryParams.js';
import '../../../core/enums/BetHistoryFilterTypes.js';
import '../../../core/enums/GameThemeTypes.js';
import '../../../core/enums/RequestStatus.js';
import '../../../core/enums/FetchDefaultPaths.js';
import '../../../core/enums/ResponseCodes.js';
import { _ as gameConfigStore, y as freeBetStore, a1 as betDataStore } from '../../../../environmentBuilder-3507f66e.js';
import '../../../core/store/chatStore.js';
import '../../../core/store/wageringStore.js';
import '../../../core/store/roundInfoStore.js';
import '../../../core/store/userCountStore.js';
import '../../../core/store/gameResultStore.js';
import '../../../core/store/resultHashStore.js';
import '../../../core/store/userWinBetsStore.js';
import '../../../core/store/notificationStore.js';
import '../../../core/store/selectedResultInfoStore.js';
import '../../../core/store/forCrashGame/inputValidationStore.js';
import '../../../core/store/forCrashGame/totalBetStore.js';
import '../../../core/store/forCrashGame/resultReportStore.js';
import '../../../core/store/forCrashGame/gameStore.js';
import '../../../core/services/liveConnection/types.js';
import 'axios';
import '../../../core/services/sound/types.js';
import '../../../core/services/sound/SoundService.js';
import '../../../core/services/sound/defaultSounds.js';
import '../../../core/services/api/types.js';
import '../../../core/services/ApiServices.js';
import '../../../../momentFormat-e9197995.js';
import '../../../core/polyfill.js';
import { handleQuickButtonClick } from '../../../core/helpers/quickBetAmount.js';
import 'mobx';
import '../../../core/classes/httpResponse/index.js';
import '@microsoft/signalr';
import '../../../core/enums/BogLineGameConfig.js';
import '../../../core/helpers/parseQuery.js';
import '../../../core/enums/StatisticsSortingTypes.js';
import '../../../core/services/api/BaseApiService.js';
import '../../../core/helpers/deepCopy.js';
import '../../../../table-line/t_types/enums/BetResponseCode.js';
import '../../../../table-line/t_types/enums/BetErrorMessages.js';
import '../../../../table-line/t_types/enums/NotificationByResponseCode.js';
import '../../../../table-line/t_types/enums/FreeChipTypes.js';
import '../../../../table-line/t_types/enums/PopupTypes.js';
import '../../../core/helpers/formatDate.js';
import '../../../core/helpers/isMobile.js';
import '../../../core/enums/bogGameNames.js';
import '../../../core/helpers/updateHalfBets.js';
import 'howler';
import '../../../../_commonjsHelpers-17aad09c.js';

var QuickBetAmountButtons = observer(function (_a) {
    var sectionIndex = _a.sectionIndex;
    var _b = gameConfigStore.limits, quickBets = _b.quickBets, maxBet = _b.maxBet; // todo  x2 /2 allIn max btn er@nael
    var activeFreeBet = freeBetStore.activeFreeBet;
    var setBetAmount = betDataStore.setBetAmount, setIsAmountChangeCustom = betDataStore.setIsAmountChangeCustom, betsSectionsData = betDataStore.betsSectionsData;
    var isAmountChangeCustom = betsSectionsData[sectionIndex].isAmountChangeCustom;
    var _c = __read(useState(null), 2), lastClicked = _c[0], setLastClicked = _c[1];
    var _d = __read(useState(0), 2), accAmount = _d[0], setAccAmount = _d[1];
    var handleClick = useCallback(function (amt) {
        var params = {
            amount: amt,
            index: sectionIndex,
            isAmountChangeCustom: isAmountChangeCustom,
            lastClicked: lastClicked,
            accAmount: accAmount,
            maxBet: maxBet,
            setLastClicked: setLastClicked,
            setAccAmount: setAccAmount,
            setBetAmount: setBetAmount,
            setIsAmountChangeCustom: setIsAmountChangeCustom,
        };
        handleQuickButtonClick(params);
    }, [sectionIndex, isAmountChangeCustom, lastClicked, accAmount, maxBet, setBetAmount, setIsAmountChangeCustom]);
    return (!!(quickBets === null || quickBets === void 0 ? void 0 : quickBets.length) && (React.createElement("div", { className: "aviabet-bet-section-small-btn-wrp ".concat(activeFreeBet.id ? 'disabled' : '') }, quickBets.map(function (amount) { return (React.createElement("div", { key: amount, className: 'aviabet-bet-section-small-btn', onClick: function () { return handleClick(amount); } },
        React.createElement("span", null, amount))); }))));
});

export { QuickBetAmountButtons };
